import Cookies, { CookieSetOptions } from "universal-cookie";
import config from "../../../../config/default";
import { IQueryParams } from "../../../../contexts/params/IParamsContext";

const cookies = new Cookies();

export const setCookie = (
  name: string,
  value: string,
  options: Partial<CookieSetOptions> = {}
): void => {
  cookies.set(name, value, {
    path: "/",
    domain: config.domain,
    secure: config.secureTokens,
    ...options,
  });
};

export const setCookiesAccessToken = (accessToken: string) => {
  setCookie("accessToken", accessToken);
};

export const setCookiesRefreshToken = (refreshToken: string) => {
  setCookie("refreshToken", refreshToken);
};

export const validateUrlParameters = (params: IQueryParams) => {
  const redirectURL = params.url || null;
  const rules = params.rules || null;
  const redirectPath = params.path || null;

  return { redirectURL, rules, redirectPath };
};

/**
 * Resolve a URL final de redirecionamento após login.
 * Prioriza a URL dos parâmetros (fluxo legado); se ausente, usa a URL retornada pelo backend.
 * Lança erro se nenhuma URL estiver disponível.
 */
export const resolveRedirectURL = (
  paramsURL: string | null,
  backendURL: string | null,
  redirectPath: string | null
): string => {
  const finalRedirectURL = paramsURL || backendURL;

  if (!finalRedirectURL) {
    throw new Error(
      "Não foi possível determinar a URL de redirecionamento. Entre em contato com o suporte."
    );
  }

  return redirectPath ? finalRedirectURL + redirectPath : finalRedirectURL;
};

export const checkTokenInParams = (): boolean => {
  const url = window.location.href;

  const hashIndex = url.indexOf("#");
  if (hashIndex === -1) return false;

  const hash = url.slice(hashIndex + 1); // ex: "/login?token=abc123"
  const queryIndex = hash.indexOf("?");
  if (queryIndex === -1) return false;

  const queryString = hash.slice(queryIndex + 1); // "token=abc123"
  const params = new URLSearchParams(queryString);

  return params.has("token");
};

export const getRulesFromUrl = (): string | null => {
  const url = window.location.href;

  const hashIndex = url.indexOf("#");
  if (hashIndex === -1) return null;

  const hash = url.slice(hashIndex + 1);

  const params = new URLSearchParams(hash.split("?")[1]);

  return params.get("rules");
};

export const getTokenDecodedFromUrl = (): string | null => {
  const url = window.location.href;

  const hashIndex = url.indexOf("#");
  if (hashIndex === -1) return null;

  const hash = url.slice(hashIndex + 1);

  const params = new URLSearchParams(hash.split("?")[1]);

  const token = params.get("token");

  if (!token) return null;

  try {
    return atob(token);
  } catch (error) {
    console.error("Erro ao decodificar o token: ", error);
    return null;
  }
};
